module.exports = "/8/4-cap-phat-bo-nho-dong/index.html.e0fca4aed8a1bfd6079218b8f9cd5649.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/31145.md
 ** module id = 570
 ** module chunks = 0
 **/